const baseSize = 12;
function setRem() {
  const scale = document.documentElement.clientWidth / 853;
  document.documentElement.style.fontSize = baseSize * scale + 'px';
}
setRem();
window.onresize = function () {
  setRem();
};